<template>
    <b-modal id="modal-konfirmasi" title="Konfirmasi Pembayaran" size="lg"
        no-close-on-backdrop no-close-on-esc :hide-header-close="isSubmitting"
        :ok-title="isSubmitting ? 'Membayar...' : 'Bayar'"
        :ok-disabled="isSubmitting"
        @ok.prevent="doSubmit"
        @shown="hitungKemungkinanPembayaran"
        cancel-title="Tutup" auto-focus-button="ok"
    >
        Konfirmasi untuk melakukan pembayaran 
        <strong v-if="tipePembayaran == 'PP'">PERPANJANGAN</strong> 
        <strong v-else>PELUNASAN</strong> dengan rincian sebagai berikut:

        <div class="detail-data-wrapper mt-4 mb-4">
            <h6 class="form-title mb-2">DATA PEMBAYARAN</h6>

            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Total Pembayaran</b-col>
                <b-col>
                    <strong>Rp. {{ $helper.addThousandSeparator(totalPembayaran) }}</strong>
                </b-col>
            </b-row>

            <b-row class="mb-2" v-if="angsuranPokok > 0 && tipePembayaran == 'PP'">
                <b-col cols="5" class="detail-data-label">Angsuran Pokok</b-col>
                <b-col>
                    <strong>Rp. {{ $helper.addThousandSeparator(angsuranPokok) }}</strong>
                </b-col>
            </b-row>

            <b-row class="mb-2" v-else>
                <b-col cols="5" class="detail-data-label">Angsuran Pokok</b-col>
                <b-col>
                    <strong>Rp. 0</strong>
                </b-col>
            </b-row>

            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Total Uang yang Harus Diterima</b-col>
                <b-col>
                    <strong>Rp. {{ $helper.addThousandSeparator(angsuranPokok + totalPembayaran) }}</strong>
                </b-col>
            </b-row>
        </div>

        <b-form-group label="Nominal Pembayaran" v-if="isTunai == 1" description="Masukkan nominal uang yang diserahkan oleh nasabah">
            <b-input-group prepend="Rp.">
                <b-form-input 
                    v-model="localNominalPembayaran"
                    name="nominalPembayaran"
                    @input="updateNominalPembayaran"
                    type="text"
                    @keypress="validateNumberInput"
                />
            </b-input-group>
        </b-form-group>
        <div class="mt-2" v-if="isTunai == 1">
            <b-button
            v-for="(jumlah, index) in kemungkinanPembayaran"
            :key="index"
            variant="outline-primary"
            size="sm"
            class="mr-2 mb-2"
            @click="pilihPembayaran(jumlah)"
            >
            {{ formatRupiah(jumlah) }}
            </b-button>
        </div>

        Pastikan anda telah menerima uang sebesar Nominal Pembayaran yang anda isi diatas.
    </b-modal>
</template>

<script>
export default {
    name: 'modal-konfirmasi',
    props: {
        isSubmitting: { type: Boolean, required: true },
        tipePembayaran: { type: String, required: true },
        angsuranPokok: { type: Number, required: true },
        totalPembayaran: { type: Number, required: true },
        isTunai: { type: Number, required: true },
        nominalPembayaran: { type: [Number, String], required: true },

    },
    data() {
        return {
            localNominalPembayaran: this.nominalPembayaran,
            // totalPembayaran: 146500,
            kemungkinanPembayaran: [],
            pecahanUang: [500, 1000, 2000, 5000, 10000, 20000, 50000, 100000]
        };
    },
    watch: {
        nominalPembayaran(newVal) {
            this.localNominalPembayaran = newVal;
        }
    },
    methods: {
        doSubmit() {
            this.$emit("exec-submit");
        },
        updateNominalPembayaran() {
            this.$emit("update:nominalPembayaran", this.localNominalPembayaran);
        },
        validateNumberInput(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
                },
        hitungKemungkinanPembayaran() {
        const hasil = new Set();
        this.pecahanUang.forEach((pecahan) => {
        const kelipatan = Math.ceil((this.angsuranPokok + this.totalPembayaran) / pecahan) * pecahan;
        hasil.add(kelipatan);
      });
      this.kemungkinanPembayaran = Array.from(hasil).sort((a, b) => a - b);
      
    },
    formatRupiah(angka) {
      return angka.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    pilihPembayaran(jumlah) {
        this.localNominalPembayaran = jumlah.toString();
        this.$emit("update:nominalPembayaran", this.localNominalPembayaran);
        }
    },
    created(){
        this.hitungKemungkinanPembayaran()
    
    }
};
</script>
